const EMAIL_MFA_OK_KEY = 'alea.emailMfa.verifiedUid';
/** Blocks shell entry until finishPrimarySignIn resolves email-MFA (or throws the challenge). */
const EMAIL_MFA_GATE_KEY = 'alea.emailMfa.gateUid';

function writeStorage(storage: Storage | undefined, key: string, value: string | null): void {
  if (!storage) return;
  try {
    if (value) storage.setItem(key, value);
    else storage.removeItem(key);
  } catch {
    // Private mode / quota.
  }
}

function readStorage(key: string): string | null {
  try {
    if (typeof sessionStorage !== 'undefined') {
      const fromSession = sessionStorage.getItem(key);
      if (fromSession) return fromSession;
    }
  } catch {
    // ignore
  }
  try {
    if (typeof localStorage !== 'undefined') return localStorage.getItem(key);
  } catch {
    return null;
  }
  return null;
}

/** Proof that email MFA was completed for this Firebase uid (survives Safari PTR). */
export function markEmailMfaVerified(uid: string): void {
  const id = String(uid ?? '').trim();
  if (!id) return;
  writeStorage(typeof sessionStorage !== 'undefined' ? sessionStorage : undefined, EMAIL_MFA_OK_KEY, id);
  writeStorage(typeof localStorage !== 'undefined' ? localStorage : undefined, EMAIL_MFA_OK_KEY, id);
  writeStorage(typeof sessionStorage !== 'undefined' ? sessionStorage : undefined, EMAIL_MFA_GATE_KEY, null);
}

export function clearEmailMfaVerified(): void {
  writeStorage(typeof sessionStorage !== 'undefined' ? sessionStorage : undefined, EMAIL_MFA_OK_KEY, null);
  writeStorage(typeof localStorage !== 'undefined' ? localStorage : undefined, EMAIL_MFA_OK_KEY, null);
}

export function isEmailMfaVerifiedFor(uid: string): boolean {
  const id = String(uid ?? '').trim();
  if (!id) return false;
  return readStorage(EMAIL_MFA_OK_KEY) === id;
}

/**
 * Mark that primary sign-in is resolving email MFA for this uid.
 * Must be set synchronously after password/OAuth success so onAuthStateChanged
 * cannot enter the shell before Login handles an email-MFA challenge.
 */
export function markEmailMfaGatePending(uid: string): void {
  if (typeof sessionStorage === 'undefined') return;
  const id = String(uid ?? '').trim();
  if (!id) return;
  sessionStorage.setItem(EMAIL_MFA_GATE_KEY, id);
}

export function clearEmailMfaGatePending(): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(EMAIL_MFA_GATE_KEY);
}

export function isEmailMfaGatePendingFor(uid: string): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  const id = String(uid ?? '').trim();
  if (!id) return false;
  return sessionStorage.getItem(EMAIL_MFA_GATE_KEY) === id;
}

export function clearEmailMfaSession(): void {
  clearEmailMfaVerified();
  clearEmailMfaGatePending();
}
